import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { find } from 'lodash';
import FilerrShape from '../../PropsShape/FilerrShape';
import Avatar from '../Avatar';
import Navigation from '../Navigation';
import MediaViewer from '../../../MediaViewer';
import AnnotationsToggle from '../AnnotationsToggle';
import * as SettingsSelectors from '../../selectors/settings';
import * as CommentsSelectors from '../../selectors/comments';
import * as CollaboratorsSelectors from '../../selectors/collaborators';
import * as FilerrsSelectors from '../../selectors/filerrs';

export class MediaContainer extends Component {
    constructor() {
        super();

        this.markersSetUp = this.markersSetUp.bind(this);
    }

    markersSetUp(comment) {
        const collaborator = find(this.props.collaborators, (collaborator) => collaborator.id === comment.collaboratorId);
        return collaborator && <Avatar username={collaborator.username} src={collaborator.userImage} size={16} className="avatar-marker"/>;
    }

    render() {
        const {
            onMediaLoad,
            filerr,
            markers,
            source,
            children,
            onMarkerClick,
            onProgressClick,
            onPlay,
            close
        } = this.props;

        return (
            <Navigation close={close}>
                {children}
                <MediaViewer filerr={filerr}
                    source={source}
                    onLoad={onMediaLoad}
                    markers={markers}
                    markersTemplate={this.markersSetUp}
                    onMarkerClick={onMarkerClick}
                    onProgressClick={onProgressClick}
                    onPlay={onPlay}
                    extraControls={<AnnotationsToggle/>}/>
            </Navigation>
        );
    }
}

MediaContainer.propTypes = {
    source: PropTypes.string,
    filerr: FilerrShape.isRequired,
    onMediaLoad: PropTypes.func,
    collaborators: PropTypes.array,
    markers: PropTypes.array,
    onMarkerClick: PropTypes.func,
    onProgressClick: PropTypes.func,
    onPlay: PropTypes.func,
    children: PropTypes.any,
    close: PropTypes.func
};

MediaContainer.defaultProps = {
    loadedMedia: {},
    currentFile: null,
    source: null,
    markers: [],
    collaborators: [],
    onMarkerClick: () => true,
    onProgressClick: () => true,
    onPlay: () => true
};

const mapStateToProps = (state) => ({
    filerr: FilerrsSelectors.getCurrentFilerr(state),
    collaborators: CollaboratorsSelectors.getCurrentGroupCollaborators(state),
    markers: CommentsSelectors.getMarkers(state),
    source: SettingsSelectors.getSource(state)
});

export default connect(mapStateToProps)(MediaContainer);
